import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginResponse } from '../constants/LoginResponse';
import { environment } from '../../../environments/environment';

const connectNowAPI = environment.connectNowAPI;

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpClient) {}

  deleteAccountLoginAPI(
    username: string,
    password: string
  ): Promise<LoginResponse> {
    return new Promise((resolve, reject) => {
      let header = new HttpHeaders().set(
        'Timezone',
        Intl.DateTimeFormat().resolvedOptions().timeZone
      );
      const req = { email: username, password: password };
      this.http
        .post(`${connectNowAPI}/public/v1/login`, req, { headers: header })
        .subscribe({
          next: (res: any) => {
            resolve(res);
          },
          error: (err: HttpErrorResponse) => {
            console.log(err);
            reject(err.error.message);
          },
          complete: () => {
            console.log('complete');
          },
        });
    });
  }

  deleteUserAPI(token: string): Promise<LoginResponse> {
    let header = new HttpHeaders()
      .set('Authorization', 'Bearer ' + token)
      .set('Timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);

    return new Promise((resolve, reject) => {
      this.http
        .delete(`${connectNowAPI}/v1/user`, { headers: header })
        .subscribe({
          next: (res: any) => {
            resolve(res);
          },
          error: (err: HttpErrorResponse) => {
            console.log(err);
            reject(err.error.message);
          },
          complete: () => {
            console.log('complete');
          },
        });
    });
  }
}
